import script from "./sport-live-tv-filter-dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-filter-dropdown.vue?vue&type=script&setup=true&lang=js"

import "./sport-live-tv-filter-dropdown.vue?vue&type=style&index=0&id=70dc8114&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70dc8114"]])

export default __exports__